import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categoryMap } from "@/mocks/categories";
import SectionHeading from "@/components/feature/SectionHeading";

export default function EditorPick() {
  const picks = [...articles].sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="编辑精选"
        title="高分口碑必看清单"
        description="编辑部从评分、口碑与追读热度综合甄选的高分漫画，从口碑神作到人气新番一网打尽，帮你避开雷区。"
        action={
          <Link
            to="/category/scifi"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            更多推荐 <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {picks.map((a) => {
          const cat = categoryMap[a.category];
          return (
            <Link
              key={a.id}
              to={`/article/${a.slug}`}
              className="group flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-transform hover:-translate-y-1"
            >
              <div className="h-32 w-24 shrink-0 overflow-hidden rounded-md bg-background-100">
                <img
                  src={a.cover}
                  alt={`${a.title}漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-bold text-accent-900">
                    {a.rating.toFixed(1)} 分
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                    {cat?.name ?? "漫画"}
                  </span>
                </div>
                <h3 className="mt-2 line-clamp-1 text-sm font-bold text-foreground-950 md:text-base">
                  {a.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {a.summary}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {a.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-bookmark-line"></i>
                    {a.chapters}话
                  </span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}